module.exports = __webpack_public_path__ + "img/5.af50b9fc.jpg";